module.exports = __webpack_public_path__ + "static/media/voucher.be6ee493.jpg";